import { cleanup } from "../security/PublicSecure";
import { ProgramContainer } from "../entities/formTemplateDataType";

export default class URLUtils {
    static concatUrls(url: string): string {
        // if (process.env.IS_RUNTIME == 'false' && process.env.ENV !== 'local') {
        //     return window.location.href.replace("index.html", "") + url;
        // }
        // if(process.env.IS_RUNTIME == 'true'){
            return (process.env.LAYOUT_API_URL + "/" + url).replace(/([^:]\/)\/+/g, "$1");
        // } else {
            // const env = process.env.LAYOUT_API_URL?.replace("on-form-service", "form-builder");
            // return (env + "/" + url).replace(/([^:]\/)\/+/g, "$1");
        // }
        
    }
}

export const goHome = (programContainer: ProgramContainer, lang='en') => {
    let url;
    const app = programContainer.CategoryId.toLowerCase();
    if (programContainer.Profile.userId) {
        url = process.env.PUBLIC_CXP_WEB_BASE_PATH + '/auth/signin?redirectUri='  + (lang === 'en' ? '' : '/fr') + '/dashboard';
    } else {
        url = lang === 'en' ? "https://www.ontario.ca/page/government-ontario" : "https://www.ontario.ca/fr/page/gouvernement-de-lontario";
    }
    cleanup(app, programContainer);
    window.location.href = url;
}

export const getAppNameFromPath = () => {
    let storedUrl = sessionStorage.getItem('preAuthUrl') || window.location.href;
    let appName = '';
   
    if (storedUrl && !storedUrl.includes("#code=")) {
      storedUrl = storedUrl.replace("/fr", "");
      let pathSegmentsAll = storedUrl.split('#');

      if (pathSegmentsAll.length > 1) {
        appName = pathSegmentsAll[1].replace(/\/+/g, "");
      }
    }
    return appName;
}

export const handleFormBuilderLink = () => {
    setTimeout(() => {
        sessionStorage.setItem('preAuthUrl', window.location.href);
        window.location.reload();
    });
}

export const setParam = (url: string, param?: string, value?: string) => {
    if (!url || !param) return url;

    let newUrl = new URL(url);
    if (!value) {
        newUrl.searchParams.delete(param);
    } else {
        newUrl.searchParams.set(param, value);
    }
    return newUrl.toString();
}